export default function Craftsmanship() {
  return (
    <section className="mx-auto max-w-140 px-6 pt-5 pb-10 sm:pt-10 sm:pb-20">
      <div className="border-y border-border py-12 text-center sm:py-16">
        <p className="font-title text-xl leading-snug tracking-tight sm:text-2xl">
          The juggler makes impossible coordination look effortless.
          <br className="hidden sm:inline" /> That&apos;s what good tools do.
        </p>
        <p className="mt-5 text-base leading-relaxed text-muted-foreground sm:text-lg">
          Complex underneath, simple on the outside, obsessively built for
          people who care about their craft.
        </p>
      </div>
    </section>
  )
}
